import {BaSeButton, BaSeHeading6, BaSeIcon, BaSeParagraph} from "@base/react"
import ModalDefault from "../modals/modal-default"
import {useEffect, useMemo, useRef, useState} from "react"
import {Link, useNavigate} from "react-router-dom"
import moment from "moment"
import Loading from "../loading"
import {eventTag, getCurrentCNPJ, truncateText} from "../../services/utils"
import AvatarGroup from "./avatar-group"
import SharePlanning from "./share-planning"
import {getUsersWithPlanner} from "../../mocks/helpers"
import StatusLabel from "./status-label"
import ColoredProgressBar from "../colored-progress-bar"
import {toast} from "react-toastify";
import ToastContent from "../toastContent";
import iconSuccess from "../../assets/images/icons/check-circle.png";
import ApiPlannings from "../../services/planning";
import {useApp} from "../../hooks/use-app";
import iconError from "../../assets/images/icons/exclamation-octagon.png";
import Opinion from "./opinion";
import {monthNames} from "../../mocks/consts";
import "./index.scss"

const apiPlannings = ApiPlannings()
const COLORS = [
  'linear-gradient(45deg, #84F4BC 0%, #40BBFF 100%)', // 1
  'linear-gradient(45deg, #9285F9 0%, #CD5BE8 100%)',
  'linear-gradient(45deg, #3B4AFF 0%, #40BBFF 100%)',
  'linear-gradient(45deg, #84F4BC 0%, #E4F998 100%)',
  'linear-gradient(45deg, #CD5BE8 0%, #FFABAB 100%)',
  'linear-gradient(45deg, #FFB380 0%, #FFED69 100%)',
  'linear-gradient(45deg, #F4455A 0%, #FFABAB 100%)', // 7
]
function getCardColor(cardId) {
  return COLORS[Math.abs(cardId - 1) % COLORS.length]
}
const currentYear = new Date().getFullYear()

const CardStatus = ({
                      data,
                      isFinished,
                      showDuplicate = true,
                      event = {},
                      clickOptions,
                      isOpen,
                      onUserRemoved,
                      hideLoading,
                      isMonitoring,
                      isConsulting = false,
                      isRemoved = false,
                      isArchived = false,
                      callbackFinalized,
                    }) => {
  const {
    companies,
    reachedTheLimitOfPlanning,
    updateNumberOfActivePlanning,
  } = useApp()
  const currentCnpj = useMemo(() => {
    return getCurrentCNPJ(companies) || null
  }, [companies])
  const navigate = useNavigate()
  const [showModal, setShowModal] = useState(false)
  const [showModalLimitPlannings, setShowModalLimitPlannings] = useState(false)
  const [showShareModal, setShowShareModal] = useState(false)
  const [showOpinionModal, setShowOpinionModal] = useState(false)
  const [open, setOpen] = useState(false)
  const [showLoading, setShowLoading] = useState(false)

  const optionsRef = useRef(null)

  const isPlanner = data.planner?.is_planner || false
  const showMonitoring = (!data.postCreditId && isFinished && data.data.fluxo?.saidas?.length > 0)

  const plannerData = useMemo(() => {
    if (!data?.planner) return null

    return {
      name: data.planner.name_planner || '',
      role: 'Planejador',
    }
  }, [data?.planner])
  const allUsers = useMemo(() => {
    return getUsersWithPlanner(data.invites, plannerData)
  }, [data.invites, plannerData])

  const nameMonitoring = isMonitoring && data?.monitoring ? `${monthNames[data?.monitoring?.month - 1] || ""} ${data?.monitoring?.year}`.trim() : null

  const handleRemovedUser = (userId) => {
    if (onUserRemoved) {
      onUserRemoved(data.id, userId)
    }
  }

  const openModal = () => {
    setShowModal(true)
  }
  const closeModal = () => {
    setShowModal(false)
  }

  const closeShareModal = () => {
    setShowShareModal(false)
  }
  const openShareModal = () => {
    eventTag(event?.name, "atendimento", event?.action, "Compartilhar")
    setShowShareModal(true)
  }

  const closeOpinionModal = () => {
    setShowOpinionModal(false)
  }
  const openOpinionModal = () => {
    setShowOpinionModal(true)
  }

  const handleDeletePlan = () => {
    setShowModal(false)
    setOpen(false)
    setShowLoading(true)
    eventTag(event?.name, event?.category, event?.action, "Confirmar exclusão")
    deletePlanning()
  }
  const handleRestorePlan = () => {
    setShowModal(false)
    setOpen(false)
    setShowLoading(true)
    eventTag(event?.name, event?.category, event?.action, "Restaurar planejamento")
    restorePlanningValidation()
  }
  const handleUnarchivePlan = () => {
    setShowModal(false)
    setOpen(false)
    setShowLoading(true)
    eventTag(event?.name, event?.category, event?.action, "Desarquivar planejamento")
    unarchivePlanning()
  }

  const restorePlanningValidation = () => {
    if (reachedTheLimitOfPlanning) {
      setShowModalLimitPlannings(true)

      eventTag(
        event.name,
        event.category,
        "modal",
        "Limite Máximo de Planejamentos"
      )

      return
    }

    restorePlanning()
  }
  const deletePlanning = () => {
    const id = data.id
    apiPlannings
      .deletePlanning(id)
      .then((res) => {
        if (callbackFinalized) callbackFinalized({ id: data.id, type: "delete", status: 'success', data: res?.data })
        eventTag(
          event.name,
          event.category,
          "submit",
          "Exclusão de planejamento"
        )

        toast.success(
          <ToastContent
            title="Sucesso!"
            description="Planejamento excluído com sucesso."
          />,
          {
            icon: () => <img src={iconSuccess} alt="icon" />,
          }
        )
      })
      .catch((err) => {
        console.warn(err)
        if (callbackFinalized) callbackFinalized({ id: data.id, type: "delete", status: 'error', data: err })
      })
      .finally(() => {
        if (callbackFinalized) callbackFinalized({ id: data.id, type: "delete", status: 'finalized', data: null })
        updateNumberOfActivePlanning()
        setShowLoading(false)
      })
  }
  const restorePlanning = () => {
    const id = data.id

    apiPlannings
      .updatePlanning({ in_trashcan: false }, id)
      .then((res) => {
        if (callbackFinalized) callbackFinalized({ id: data.id, type: "restore", status: 'success', data: res?.data })

        eventTag(
          event.name,
          event.category,
          "submit",
          "Restauração de planejamento"
        )

        toast.success(
          <ToastContent
            title="Sucesso!"
            description="Planejamento restaurado com sucesso."
          />,
          {
            icon: () => <img src={iconSuccess} alt="icon" />,
          }
        )
      })
      .catch((err) => {
        console.warn(err)
        if (callbackFinalized) callbackFinalized({ id: data.id, type: "restore", status: 'error', data: err })
      })
      .finally(() => {
        if (callbackFinalized) callbackFinalized({ id: data.id, type: "restore", status: 'finalized', data: null })
        updateNumberOfActivePlanning()
        setShowLoading(false)
      })
  }
  const duplicatePlannings = () => {
    const id = data.id
    apiPlannings
      .duplicatePlanning(id, currentCnpj)
      .then((res) => {
        if (callbackFinalized) callbackFinalized({ id: data.id, type: "duplicate", status: 'success', data: res?.data })

        eventTag(
          event.name,
          event.category,
          "submit",
          "Duplicação de planejamento"
        )
      })
      .catch((err) => {
        console.warn(err)
        if (err.status === 409) {
          toast.error(
            <ToastContent
              title="Não é possível duplicar"
              description="Você atingiu o limite máximo de <strong>120 planejamentos</strong>."
            />,
            {
              icon: () => <img src={iconError} alt="icon" />,
            }
          )
        }

        if (callbackFinalized) callbackFinalized({ id: data.id, type: "duplicate", status: 'error', data: err })
      })
      .finally(() => {
        if (callbackFinalized) callbackFinalized({ id: data.id, type: "duplicate", status: 'finalized', data: null })
        updateNumberOfActivePlanning()
        setShowLoading(false)
      })
  }
  const monitorPlanning = () => {
    const id = data.id
    apiPlannings
      .monitorPlanning(id)
      .then((res) => {
      if (callbackFinalized) callbackFinalized({ id: data.id, type: "monitor", status: 'success', data: res?.data })

        toast.success(
          <ToastContent
            title="Sucesso!"
            description="Operação realizada com sucesso."
          />
        )

        eventTag(
          event.name,
          "post_credit",
          "submit",
          `Iniciando monitoramento: ${res?.data?.title}`
        )

        navigate(`/planejamento/${res.data.id}/pos-credito`)
      })
      .catch((err) => {
        console.warn(err)
        if (callbackFinalized) callbackFinalized({ id: data.id, type: "monitor", status: 'error', data: err })
        if (err.message.includes("Planejamento já monitorado")) {
          const planId = err.message.split(" ")[4].replace("ID:", "")
          navigate(`/planejamento/${planId}/pos-credito`)
        } else {
          toast.error(
            <ToastContent
              title="Erro"
              description="Não foi possível realizar a operação."
            />
          )
        }
      })
      .finally(() => {
        if (callbackFinalized) callbackFinalized({ id: data.id, type: "monitor", status: 'finalized', data: null })
        setShowLoading(false)
      })
  }
  const archivePlanning = () => {
    const id = data.postCreditId
    apiPlannings
      .archivePlanning(id)
      .then((res) => {
        if (callbackFinalized) callbackFinalized({ id: data.id, type: "archive", status: 'success', data: res?.data })

        toast.success(
          <ToastContent
            title="Sucesso!"
            description="Planejamento arquivado com sucesso."
          />,
          {
            icon: () => <img src={iconSuccess} alt="success" />,
          }
        )

        eventTag(
          event.name,
          event.category,
          "submit",
          "Arquivamento de planejamento"
        )
      })
      .catch((err) => {
        console.warn(err)
        if (callbackFinalized) callbackFinalized({ id: data.id, type: "archive", status: 'error', data: err })

        toast.error(
          <ToastContent
            title="Erro"
            description="Não foi possível arquivar o planejamento."
          />,
          {
            icon: () => <img src={iconError} alt="error" />,
          }
        )
      })
      .finally(() => {
        if (callbackFinalized) callbackFinalized({ id: data.id, type: "archive", status: 'finalized', data: null })
        updateNumberOfActivePlanning()
        setShowLoading(false)
      })
  }
  const unarchivePlanning = () => {
    const id = data.postCreditId
    apiPlannings
      .restorePlanning(id)
      .then((res) => {
        if (callbackFinalized) callbackFinalized({ id: data.id, type: "unarchive", status: 'success', data: res?.data })

        eventTag(
          event?.name,
          event?.category,
          "submit",
          "Desarquivamento de planejamento"
        )
        toast.success(
          <ToastContent
            title="Sucesso!"
            description="Planejamento desarquivado com sucesso."
          />,
          {
            icon: () => <img src={iconSuccess} alt="icon" />,
          }
        )
      })
      .catch((err) => {
        console.warn(err)
        toast.error(
          <ToastContent
            title="Erro"
            description="Não foi possível desarquivar o planejamento."
          />,
          {
            icon: () => <img src={iconError} alt="error" />,
          }
        )
        if (callbackFinalized) callbackFinalized({ id: data.id, type: "unarchive", status: 'error', data: err })
      })
      .finally(() => {
        if (callbackFinalized) callbackFinalized({ id: data.id, type: "unarchive", status: 'finalized', data: null })
        setShowLoading(false)
      })
  }

  const getMenuOptions = () =>  {
    const options = []
    const opinion = {
      key: 'opinion',
      label: 'Acompanhamento',
      icon: 'subject',
      action: () => {
        setOpen(false)
        clickOptions()
        eventTag('accompaniment', "acompanhamento", event?.action, "Abrir acompanhamento")
        openOpinionModal()
      },
    }

    // Monitoring tab
    if (isMonitoring) {
      options.push({
        key: 'view',
        label: 'Visualizar',
        icon: 'eye',
        action: () => {eventTag(event?.name, "post_credit", event?.action, "Visualizar")},
        linkTo: `/planejamento/${data.postCreditId}/pos-credito`
      })

      options.push({
        key: 'archive',
        label: 'Arquivar',
        icon: 'archive',
        action: () => {
          setOpen(false)
          eventTag(event?.name, event?.category, event?.action, "Arquivar")
          archivePlanning()
        }
      })

      if (isPlanner) {
        options.push({
          key: 'share',
          label: 'Compartilhar',
          icon: 'share',
          action: openShareModal
        })
      }

      return options
    }

    if (!isConsulting && !isPlanner) {
      options.push({
        key: 'view',
        label: 'Visualizar',
        icon: 'eye',
        action: () => { eventTag(event?.name, event?.category, event?.action, "Visualizar") },
        linkTo: isFinished ? `/planejamento/${data.id}/resultados` : `/planejamento/${data.id}`
      })

      if (showDuplicate) {
        options.push({
          key: 'duplicate',
          label: 'Duplicar',
          icon: 'copy',
          action: () => {
            setOpen(false)
            setShowLoading(true)
            clickOptions()
            eventTag(event?.name, event?.category, event?.action, "Duplicar")
            duplicatePlannings()
          }
        })
      }

      options.push(opinion)
      return options
    }

    // View or Edit
    if (isFinished) {
      options.push({
        key: 'view',
        label: 'Visualizar',
        icon: 'eye',
        action: () => {eventTag(event?.name, event?.category, event?.action, "Visualizar")},
        linkTo: `/planejamento/${data.id}/resultados`
      })
    } else {
      options.push({
        key: 'edit',
        label: 'Editar',
        icon: 'design/edit-2-line',
        action: () => {eventTag(event?.name, event?.category, event?.action, "Editar")},
        linkTo: `/planejamento/${data.id}`
      })
    }

    // Duplicate
    if (showDuplicate) {
      options.push({
        key: 'duplicate',
        label: 'Duplicar',
        icon: 'copy',
        action: () => {
          setOpen(false)
          setShowLoading(true)
          clickOptions()
          eventTag(event?.name, event?.category, event?.action, "Duplicar")
          duplicatePlannings()
        }
      })
    }

    // Opinion
    options.push(opinion)

    if (!isConsulting) {
      // Delete
      options.push({
        key: 'delete',
        label: 'Excluir',
        icon: 'system/delete-bin-line',
        action: openModal
      })
    }

    // Share option
    if (isPlanner) {
      options.push({
        key: 'share',
        label: 'Compartilhar',
        icon: 'share',
        action: openShareModal
      })
    }

    // Monitoring option
    if (isPlanner && showMonitoring) {
      options.push({
        key: 'monitor',
        label: 'Monitorar',
        icon: 'graph-bar',
        action: () => {
          setOpen(false)
          setShowLoading(true)
          clickOptions()
          eventTag(event?.name, "post_credit", event?.action, "Monitorar")
          monitorPlanning()
        }
      })
    }

    return options;
  }

  useEffect(() => {
    if (!isOpen) return

    function handleClickOutside(event) {
      const isOptionsButton = event.target.closest('.open-options')

      if (isOptionsButton) {
        return
      }

      if (optionsRef.current && !optionsRef.current.contains(event.target)) {
        clickOptions()
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, clickOptions])
  useEffect(() => {
    if (hideLoading) setShowLoading(false)
  }, [hideLoading])

  return (
    <>
      <ModalDefault
        callBackClose={closeModal}
        show={showModal}
        title="Excluir planejamento"
      >
        <div className="modal-text-area" style={{ paddingTop: "8px" }}>
          <BaSeParagraph>
            Tem certeza que deseja excluir esse planejamento? <br /> Você ainda
            pode recuperá-lo, acessando{" "}
            <span style={{ fontWeight: "700" }}>
              {" "}
              <br /> “Planejamentos excluídos”
            </span>
            .
          </BaSeParagraph>
        </div>
        <div
          className="modal-buttons-area"
          style={{
            display: "flex",
            gap: 16,
            paddingTop: "32px",
            justifyContent: "right",
          }}
        >
          <div className="button-back">
            <BaSeButton value="Não, voltar" onClick={closeModal} />
          </div>

          <BaSeButton
            color="#2E5DE6"
            value="Sim, continuar"
            onClick={handleDeletePlan}
          />
        </div>
      </ModalDefault>
      <ModalDefault
        show={showModalLimitPlannings}
        callBackClose={() => setShowModalLimitPlannings(false)}
        square
        title="Limite Máximo de Planejamentos"
      >
        <div className="notes-modal">
          <BaSeHeading6>
            Você atingiu o limite máximo de <strong>120 planejamentos</strong>{" "}
            para o ano de {currentYear}.
          </BaSeHeading6>
          <br />
          <BaSeHeading6>
            Para adicionar novos planejamentos, por favor, exclua um
            planejamento já existente.
          </BaSeHeading6>
          <br />
          <BaSeButton value="Fechar" onClick={() => setShowModalLimitPlannings(false)} />
        </div>
      </ModalDefault>
      <ModalDefault
        callBackClose={closeShareModal}
        show={showShareModal}
        title={isMonitoring ? "Compartilhar pós-crédito" : "Compartilhar planejamento"}
        children={
          <SharePlanning
            data={data}
            isPlanner={isPlanner}
            event={event}
            postCredit={isMonitoring}
          />
        }
      />
      <Opinion planningId={data?.id} currentCnpj={currentCnpj} show={showOpinionModal} closeModal={closeOpinionModal} event={event} reopen={openOpinionModal} />
      <div className={`card-status ${showLoading ? "removing" : ""} ${isRemoved || isArchived ? "in-trash" : ""}`}
           style={{
             "--card-gradient": getCardColor(data?.postCreditId || data?.id)
           }}>
        <div
          className="card-status-content"
          onClick={() => {
            if (open) setOpen(false)
          }}
        >
          <div className="card-status-wrapper">
            <div className="card-status-wrapper__title">
              <h5 className="card-status-title text-ellipsis" title={data.title}>
                {data.title}
              </h5>
              {data.postCreditId && !data.isPostCredit && (<p className="card-status-flag">Planejamento Base</p>)}
            </div>
            <h6 className="card-status-subtitle" style={{margin: '6px auto'}}>
              <p>Criado em:{" "}<strong>{moment(data.createdAt).format("DD/MM/YYYY")}</strong></p> <span className="dot">•</span> <p>Última atualização:{" "}<strong>{moment(data.modifiedAt).format("DD/MM/YYYY")}</strong></p>
            </h6>
            <h6 className="card-status-subtitle">
              {
                data?.info?.cnpj_name ? <p className="text-with-ellipsis" style={{flex: 1}}><span>Empresa:</span>{" "}<strong title={data?.info?.cnpj_name} className="d-block text-ellipsis">{truncateText(data?.info?.cnpj_name, 20) || "Empresa"}</strong> <span className="dot">•</span> </p> : ""
              }
              <p className="text-with-ellipsis"><span>Criado por:</span>{" "}<strong title={data?.info?.cpf_name} className="d-block text-ellipsis">{data?.info?.cpf_name}</strong></p>
            </h6>
          </div>
          <div className="card-status-progress">
            {
              !isMonitoring ? (
                <>
                  <div className="status">
                    <p>Status do planejamento</p>
                    <StatusLabel isFinish={data?.isFinished} isRemoved={isRemoved} isArchived={isArchived} />
                  </div>
                  {
                    !isArchived && (<div className="progress">
                      <h4>{data?.progressPercentage || 0}%</h4>
                      <ColoredProgressBar barColor="#005EB8" barBackgroundColor="#F5F7FA" percentage={data?.progressPercentage || 0} />
                    </div>)
                  }
                </>
              ) : (
                <div className="status status-monitoring">
                  <StatusLabel type="monitoring"
                               textMonitoring={nameMonitoring}
                               isArchived={isArchived}
                               isLate={data?.monitoring?.status === 'overdue'} />
                  {
                    data?.monitoring?.status === 'overdue' && (<p>Atrasado</p>)
                  }
                </div>
              )
            }
          </div>
          {!isArchived && !isRemoved && data.isShared && allUsers.length > 0 && (
            <AvatarGroup
              users={allUsers}
              isPlanner={isPlanner}
              onUserRemoved={handleRemovedUser}
              postCredit={isMonitoring}
              event={event}
            />
          )}

          {showLoading ? <Loading small={true} /> : null}
          <div className="card-status-actions">
          {
            (!isRemoved && !isArchived) ? (
              <button
                className="open-options"
                onClick={(e) => {
                  e.stopPropagation()
                  clickOptions()
                }}
              >
                <BaSeIcon
                  color="#005EB8"
                  description="Menu"
                  name="system/more-2-fill"
                  size={24}
                />
              </button>
            ) : isRemoved ? (
              <button
                className="link"
                onClick={(e) => {
                  e.stopPropagation()
                  handleRestorePlan()
                }}
              >
                Restaurar
              </button>
            ) : isArchived ? (
              <button
                className="link"
                onClick={(e) => {
                  e.stopPropagation()
                  handleUnarchivePlan()
                }}
              >
                Desarquivar
              </button>
            ) : ""
          }
          </div>
        </div>
        {
          (!isRemoved && !isArchived) ? (
            <div ref={optionsRef} className={`options ${isOpen ? "open" : ""}`}>
              <ul>
                {getMenuOptions().map((option) => (
                  <li key={option.key}>
                    {option.linkTo ? (
                      <Link to={option.linkTo} onClick={option.action}>
                        <div className="link">
                          <BaSeIcon
                            color="#2E5DE6"
                            description={option.description || "Menu"}
                            name={option.icon}
                            size={24}
                          />
                          <span>{option.label}</span>
                        </div>
                      </Link>
                    ) : (
                      <button onClick={option.action}>
                        <div className="link">
                          <BaSeIcon
                            color="#2E5DE6"
                            description={option.description || "Menu"}
                            name={option.icon}
                            size={24}
                          />
                          <span>{option.label}</span>
                        </div>
                      </button>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ) : ""
        }
      </div>
    </>
  )
}

export default CardStatus
